<template>
	<div class="body" id="poster">
		<h2 class="title">校园充电桩</h2>
		<div class="div">
			<el-form class="form" :model="loginForm" :rules="rules" ref="loginForm" >
				<el-form-item class="item" prop="username">
					<!-- <el-input id="userinput" ref="userinput" v-model="loginForm.username" @keyup.enter.native="keyConfirm('loginForm', 1, $event)"></el-input> -->
					<el-input id="userinput" ref="userinput" placeholder="请输入账号" v-model="loginForm.username"></el-input>
				</el-form-item>
				<el-form-item class="item" prop="password">
					<el-input id="pwdinput" ref="pwdinput" placeholder="请输入密码" v-model="loginForm.password"
								type="password"></el-input>
				</el-form-item>
				<!-- <el-form-item class="item" prop="code">
					<span style="width: 100%;display: flex">
						<el-input @keyup.enter.native="submitForm('loginForm')" id="codeinput" placeholder="验证码" style="width: calc(100% - 110px);display: inline-block" ref="codeinput" v-model="loginForm.code"
									maxlength="4"></el-input>
						<el-image :src="captchaImg" class="captchaImg" @click="getCaptcha"></el-image>
					</span>
				</el-form-item> -->
	
				<el-form-item class="item">
					<el-button type="primary" class="btn" @click="submitForm('loginForm')">登录
					</el-button>
					<!-- <el-button @click="resetForm('loginForm')">重置</el-button> -->
				</el-form-item>
			</el-form>
			<img src="../assets/1.png" alt="">

		</div>
	</div>
</template>

<script>
import {Login} from '@/apis/user'
import qs from 'qs'

export default {
	name: "Login",
	data() {
		return {
			loginForm: {
				username: '',
				password: '',
			},
			rules: {
				username: [
					{required: true, message: '请输入用户名', trigger: 'blur'}
				],
				password: [
					{required: true, message: '请输入密码', trigger: 'blur'}
				],
			},
			captchaImg: null
		};
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					Login(this.loginForm).then(res => res.data).then(res => {
						console.log(res);
						if (res.code === 200) {
							this.$message.success(res.message)
							this.$store.commit('SET_TOKEN', res.data.token)
							localStorage.setItem('realName', res.data.realName)
							localStorage.setItem('username', res.data.username)
							this.$router.push("/index")
						} else {
							this.$message.error(res.message)
						}
					})
				} else {
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		keyConfirm(formName, index, e) {
			var keyCode = e.keyCode || e.which || e.charCode;
			this.loginForm = true
			const _this = this
			setTimeout(function () {
				if (keyCode === 13) {
					if (index === 1) {
						_this.$refs["pwdinput"].focus();
					} else if (index === 2) {
						_this.submitForm(formName);
					}
				}
			}, 1)

		}
	},
}
</script>

<style scoped>
.body {
	height: 100vh;
	width: 100%; 
	background: #0568C1;
	position: absolute
}
.title {
	font-size: 40px;
	color: white;
	text-align: center;
	top: 6%;
	position: relative;
	font-family: "华文新魏";
}

.div {
	width: 60%;
	height: 60%;
	left: 20%;
	top: 20%;
	border-radius: 20px;
	position: absolute;
	background-color: white;

	display: flex;
	flex-direction: row;
}

.div .form {
	width: 50%;
	height: 100%;
	/* padding-top: 10%; */
	display: flex;
    flex-direction: column;
    justify-content: center;
}
.item {
	width: 70%;
	left: 15%;
	position: relative;
}
.item .btn {
	width: 100%;
}
.yzm > .el-form-item__content {
	display: flex !important;
}

.captchaImg {
	width: 100px;
	margin-left: 10px;
	display: inline-block;
}

.div img {
	width: 50%;
	height: auto;
	background: rgb(224, 223, 223);
	border-radius: 0 20px 20px 0;
}

/* #poster {
	background: url("../assets/login-bg.jpg") no-repeat;
	background-position: center;
	height: 100%;
	width: 100%;
	background-size: cover;
	position: fixed;
} */

</style>